export default __webpack_public_path__ + "static/media/javaaptech.d3b0a214.jpg";